import React from 'react';
import { Navigate } from 'react-router-dom';
import {jwtDecode} from "jwt-decode";

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');

    if (!token) {
        // Redirect to login if no token exists
        return <Navigate to="/login" />;
    }

    try {
        const decoded = jwtDecode(token); // Decode and validate token
        const isTokenExpired = decoded.exp * 1000 < Date.now(); // Check expiry
        if (isTokenExpired) {
            localStorage.removeItem('token'); // Clean up expired token
            return <Navigate to="/login" />;
        }
    } catch (error) {
        console.error('Invalid token:', error);
        localStorage.removeItem('token'); // Remove invalid token
        return <Navigate to="/login" />;
    }

    return children; // Render the protected children
};

export default ProtectedRoute;
